export default __webpack_public_path__ + "static/media/dog3.a74520f7.png";